import { Component } from '@angular/core';
import { CategoryModule } from '../../appshared/masters/category/category.module';
import { CategoryService } from '../../appshared/masters/category/category.service';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { environment } from '../../../environments/environment';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-categories',
  standalone: true,
  imports: [CommonModule, TranslateModule, FontAwesomeModule, RouterLink],
  templateUrl: './categories.component.html',
  styleUrl: './categories.component.css'
})
export class CategoriesComponent {
  products: CategoryModule[] = [];
  currentLang: string = localStorage.getItem('locale') || 'en';
  ComID: number = 1;
  apiURL: string =  environment.apiUrl2 + 'Attachment/Companies/' + this.ComID + '/GnAtt/';
  categoryId!: number;
  totalItems: number = 1;

  constructor(
    private serv: CategoryService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.fillCategory();
  }

  fillCategory() {

    this.serv.getService(this.ComID,'Subcategory')
      .subscribe((res: CategoryModule[]) => {


        //this.loader.close();

        this.products = res;

        //for (var i = 0; i < length; i++) {

        //}


        for (let i = this.products.length - 1; i >= 0; i--) {
          if (this.products[i].gnCategoryID > 11) {
            this.products.splice(i, 1);
          }
        }


      },
        (err: any) => {
          //this.loader.close();
          //console.log(err);
        });
  }

}
